import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Notifica } from '../types/Notifica';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const API_ENDPOINT_NOTIFICATION = environment.API_ENDPOINT_NOTIFICATION;
const API_ENDPOINT_COT_SERVICE = environment.API_ENDPOINT_COT_SERVICE;

@Injectable({
  providedIn: 'root'
})
export class NotificheService {

  constructor(private httpClient: HttpClient) { }

  getNotifiche(): Observable<Notifica[]> {
    return this.httpClient.get<Notifica[]>(API_ENDPOINT_NOTIFICATION + '/get-notifiche');
  }
  getNotificheLette(): Observable<Notifica[]> {
    return this.httpClient.get<Notifica[]>(API_ENDPOINT_COT_SERVICE + '/notifiche-lette');
  }
  getNotificheNonLette(): Observable<Notifica[]> {
    return this.httpClient.get<Notifica[]>(API_ENDPOINT_COT_SERVICE + '/notifiche-non-lette');
  }

  getNotifichePage(page: number, size: number): Observable<any> {
    const params = {
      page: page.toString(),
      size: size.toString()
    };
    return this.httpClient.get<any>(API_ENDPOINT_NOTIFICATION + '/get-notifiche-page', { params });
  }

  leggiNotifica(idRichiesta: string): Observable<any> {
    return this.httpClient.post<any>(API_ENDPOINT_COT_SERVICE + '/notifica/letta/' + idRichiesta, null);
  }

}
